import { PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

/** 公开的平台品牌配置 */
export interface PlatformConfig {
  systemName?: string;
  recordNumber?: string;
  logoURL?: string;
  faviconURL?: string;
  footerLogoURL?: string;
  companyAddress?: string;
  footerSlogan?: string;
  contactPhone?: string;
  investorPhone?: string;
  contactEmail?: string;
  marketingEmail?: string;
  recruitmentEmail?: string;
  investorEmail?: string;
}

/** 获取无需登录的平台品牌配置 */
export function getPlatformConfig(): Promise<PlatformConfig> {
  return get(`${PREFIX.oauth}/platformconfig`);
}
